The executed action that constitutes this history item.

This action may or may not trigger a change in the status of the underlying process.
For example, an action may be to add a note against a candidate's profile,
which has no material effect on the stage through the application process.
